<template>
  <div class="-mx-1">
    <div class="px-1 w-full">
      <h2 class="font-bold text-2xl">Skladište</h2>
    </div>
    <div class="px-1 flex mt-2" v-if="selectedWarehouses.length > 0" v-for="(warehouse, index) in selectedWarehouses" :key="index">
      <div class="form-group w-1/3 pr-16">
        <label :for="`warehouse-${index}`" class="form-label">Odaberi skladište</label>
        <v-select
            :id="`warehouse-${index}`"
            :filterable="false"
            :options="warehouses"
            :reduce="warehouse => warehouse.id"
            v-model="warehouse.value"
            label="title"
        >
        </v-select>
        <input type="hidden" :name="`warehouse[${index}][id]`" :value="warehouse.value">
      </div>

      <div class="form-group w-1/8 mr-4">
        <label :for="`warehouse-quantitymin-${index}`" class="form-label">Min. količina</label>
        <input type="number" class="form-control" :name="`warehouse[${index}][quantitymin]`" v-model="warehouse.quantitymin">
      </div>
      <div class="form-group w-1/8">
        <label :for="`warehouse-quantitymax-${index+1}`" class="form-label">Max količina</label>
        <input type="number" class="form-control" :name="`warehouse[${index}][quantitymax]`" v-model="warehouse.quantitymax">
      </div>

      <div class="form-group w-1/4">
        <button :id="`remove-warehouse-${index}`" type="button" class="btn btn-delete border-0 mt-8 px-2 ml-4 hover:text-primary flex" @click="removeWarehouse(index)">Ukloni</button>
      </div>
    </div>
    <div class="flex w-1/5 items-center mb-1 mt-4">
      <button
          class="btn btn-lg btn-success"
          @click.prevent="addNewWarehouse()"
      >
        <span>Dodaj stavku</span>
      </button>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
Vue.component('v-select', vSelect);
export default {
name: "WarehouseComp",
  props:{
    warehouses:{
      type: Array,
      required: true,
    }
  },
  data(){
  return{
    listWarehouses: [],
    selectedWarehouses: [],
  }
  },
  created()
  {
    this.initWarehouse()
  },
  methods: {
    removeWarehouse(index) {
      this.selectedWarehouses.splice(index, 1)
    },
    addNewWarehouse() {
      this.selectedWarehouses.push({
        value: null,
        quantitymin: 1,
        quantitymax: 1,
      });
    },
    initWarehouse() {
      if (this.selectedWarehouses.length === 0) {
        this.addNewWarehouse()
      }
    },

  }

}
</script>

